(function ($) {
  if ($('.section_live_sessions') || $('.section-agenda')) {
    fetch("/wp-json/api/v1/livesessions").then(function (res) {
      return res.json();
    }).then(function (data) {
      var liveSessionsData = JSON.parse(data);
      var timeElapsed = 0;
      liveSessionsData.forEach(function (session) {
        if (session.isLive) {
          $("[data-session=".concat(session.ID, "]")).addClass('session--live');
        }
      });
      setInterval(function () {
        timeElapsed = timeElapsed + 3000;
        liveSessionsData.forEach(function (session) {
          if (session.time_to_start && timeElapsed > parseInt(session.time_to_start)) {
            $("[data-session=".concat(session.ID, "]")).addClass('session--live');
          }

          if (session.time_to_end && timeElapsed > parseInt(session.time_to_end)) {
            $("[data-session=".concat(session.ID, "]")).removeClass('session--live');
          }
        });

        if ($('.section_live_sessions__item.session--live').length === 0) {
          $('.section_live_sessions').addClass('section_live_sessions--no_live_sessions');
        } else {
          $('.section_live_sessions').removeClass('section_live_sessions--no_live_sessions');
        }
      }, 3000);
    });
  }
})(jQuery);